import { legalNickname, legalWebUrl } from "./regular";


export const _legalNickname = ({message}, value, callback) => {
  if (legalNickname(value)) {
    callback();
  } else {
    callback(new Error(message ? message : '请输入合法名称'));
  }
};

export const _legalWebUrl = ({message}, value, callback) => {
  if (legalWebUrl(value)) {
    callback();
  } else {
    callback(new Error(message ? message : '请输入合法地址'));
  }
};



// WEBPACK FOOTER //
// ./src/js/utils/el-form-validate-rules.js